export { default } from './Text';
import { TextProps as TProps } from './Text';

export type TextProps = TProps;
